import { useRef } from 'react';

import clsx from 'clsx';

import Avatar from '@avatar/components/Avatar';
import useEventTypesStore from '@event/store/useEventTypesStore';
import PopupWrapper from '@ui/components/PopupWrapper';
import useOnClickOutsideWithIgnore from '@ui/hooks/useOnClickOutsideWithIgnore';
import { getAssetUrl } from '@utils/getAssetUrl';

interface LoginModalProps {
  photoId?: number;
  type: 'event' | 'user';
  size?: 'regular' | 'small';
  onAvatarClick: (photoId: number) => void;
  handleClick: () => void;
  className?: string;
}

const ImageSelector = ({
  photoId,
  type,
  size = 'regular',
  onAvatarClick,
  handleClick,
  className,
}: LoginModalProps) => {
  const ref = useRef(null);
  useOnClickOutsideWithIgnore(ref, handleClick, 'ignore-click-outside');
  const { selectedEventType } = useEventTypesStore();

  const imageCount = 30;
  const urlPrefix = `/images/${type}/${selectedEventType?.name}`;

  return (
    <div
      ref={ref}
      className={clsx(
        'fixed inset-x-2 bottom-2 z-10 flex flex-wrap overflow-auto rounded-[40px] bg-brand-white-100 shadow-popup transition-all duration-300 scrollbar-hide motion-reduce:transition-none md:absolute md:inset-x-0 md:bottom-auto md:min-w-min md:pt-0 lg:pt-6',
        size === 'regular' && 'p-0 md:w-auto md:max-w-[704px] lg:px-6',
        size === 'small' &&
          'justify-center p-2 sm:h-[312px] md:left-[-20px] md:top-[-8px] md:w-[392px] md:px-2 md:py-4 lg:top-[-23px]',
        className,
      )}
    >
      <PopupWrapper handleClick={handleClick} isMaxHeightLimit={true}>
        {Array.from({ length: imageCount }).map((_, index) => (
          <Avatar
            key={index}
            imgSrc={getAssetUrl(`${urlPrefix}/${index + 1}.png`)}
            title={`Avatar ${index + 1}`}
            isAvatarActive={index + 1 === photoId}
            onClick={() => onAvatarClick(index + 1)}
            className="m-2 md:m-3"
            size={size}
          />
        ))}
      </PopupWrapper>
    </div>
  );
};

export default ImageSelector;
